/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RespiratoryMonitoringViewerAliases {
  ACTION_INACTIVATE_RESPIRATORY_MONITORING = 'action-inactivate-respiratory-monitoring',
  ACTION_NEW_RESPIRATORY_MONITORING = 'action-new-respiratory-monitoring',
  CONTEXTUAL_BAR_RESPIRATORY_MONITORING = 'contextual-bar-respiratory-monitoring',
  FIELD_DS_DISP = 'field-ds-disp',
  FIELD_DS_ESQUIPAMENTO = 'field-ds-esquipamento',
  FIELD_DS_MOD_VENT = 'field-ds-mod-vent',
  FIELD_DS_MUSCULO = 'field-ds-musculo',
  FIELD_DS_PADRAO = 'field-ds-padrao',
  FIELD_DS_RESPIRACAO = 'field-ds-respiracao',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_QT_AMPLITUDE = 'field-qt-amplitude',
  FIELD_QT_FIO = 'field-qt-fio',
  FIELD_QT_FLUXO_INSP = 'field-qt-fluxo-insp',
  FIELD_QT_FLUXO_OXIDO = 'field-qt-fluxo-oxido',
  FIELD_QT_FLUXO_OXIGENIO = 'field-qt-fluxo-oxigenio',
  FIELD_QT_FREQ_PROG = 'field-qt-freq-prog',
  FIELD_QT_FREQ_VENT = 'field-qt-freq-vent',
  FIELD_QT_OXIDO_NITRICO = 'field-qt-oxido-nitrico',
  FIELD_QT_PEEP = 'field-qt-peep',
  FIELD_QT_PIP = 'field-qt-pip',
  FIELD_QT_PVA = 'field-qt-pva',
  FIELD_QT_SATURACAO = 'field-qt-saturacao',
  FIELD_QT_TEMPO_INSP = 'field-qt-tempo-insp',
  FIELD_RECORD_DATE = 'field-record-date',
  FORM_RESPIRATORY_MONITORING_VIEWER = 'form-respiratory-monitoring-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_RECORD_DATE = 'input-record-date',
  RESPIRATORY_MONITORING_VIEWER_LAYOUT = 'respiratory-monitoring-viewer-layout',
  TEXT_DS_DISP = 'text-ds-disp',
  TEXT_DS_ESQUIPAMENTO = 'text-ds-esquipamento',
  TEXT_DS_MOD_VENT = 'text-ds-mod-vent',
  TEXT_DS_MUSCULO = 'text-ds-musculo',
  TEXT_DS_PADRAO = 'text-ds-padrao',
  TEXT_DS_RESPIRACAO = 'text-ds-respiracao',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_QT_AMPLITUDE = 'text-qt-amplitude',
  TEXT_QT_FIO = 'text-qt-fio',
  TEXT_QT_FLUXO_INSP = 'text-qt-fluxo-insp',
  TEXT_QT_FLUXO_OXIDO = 'text-qt-fluxo-oxido',
  TEXT_QT_FLUXO_OXIGENIO = 'text-qt-fluxo-oxigenio',
  TEXT_QT_FREQ_PROG = 'text-qt-freq-prog',
  TEXT_QT_FREQ_VENT = 'text-qt-freq-vent',
  TEXT_QT_OXIDO_NITRICO = 'text-qt-oxido-nitrico',
  TEXT_QT_PEEP = 'text-qt-peep',
  TEXT_QT_PIP = 'text-qt-pip',
  TEXT_QT_PVA = 'text-qt-pva',
  TEXT_QT_SATURACAO = 'text-qt-saturacao',
  TEXT_QT_TEMPO_INSP = 'text-qt-tempo-insp',
}
export { RespiratoryMonitoringViewerAliases };
